<template>
    <div style="width:100%;">
        <!-- Container per sezioni -->
        <div v-if="isContainer" class="content-container">
            <div class="d-flex btn p-0 text-start cursor-pointer" @click="scrollToElement(`#node_${node.id}_${node.type}`)">
                <a class="mt-1" :class="root && root.activeTitle === 'ALLEGATI' ? 'text-truncate' : '' + ' ms-' + indent">{{ node.activeTitle }}</a>
            </div>
            <!-- Contenuto ricorsivo -->
            <div v-if="root === null || (root && root.activeTitle !== 'ALLEGATI') || indent==1" class="col-12 m-0">
                <div v-for="childNode in node.childrens" :key="`${childNode.id}`">
                    <!-- Sezione figlio -->
                    <div v-if="childNode.type == 'section' && !childNode.filtered" class="mt-1 ms-2">
                        <TextSidebarTreeNode :node="childNode" :contentTree="contentTree" :key="`${childNode.id}`"
                            :root="root ?? node" is-container :indent="indent + 1"/>
                    </div>
                    <!-- Articoli -->
                    <div v-else>
                        <div v-if="contentTree && !contentTree.filtered && childNode.findCurrentVersion">
                            <TextSidebarTreeNode v-if="childNode.versions.length > 0" :node="childNode"
                                 :root="root ?? node" :version="childNode.findCurrentVersion()" is-article :indent="indent + 1" />
                        </div>
                        <div v-else>
                            <div v-for="version in childNode.versions" :key="version.id + version.filtered">
                                <div v-if="'filtered' in version">
                                    <div v-if="!version.filtered && childNode.type == 'content'" class="d-flex">
                                        <TextSidebarTreeNode :root="root ?? node" :node="childNode" :version="version" is-article :indent="indent + 1" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Articolo -->
        <div v-else-if="isArticle" class="cursor-pointer" style="max-width:100%" @click="scrollToElement(`#node_${node.id}_${node.type}`)">
            <a class="mt-1 text-truncate d-block" :class="'ms-'+indent" style="max-width: 100%; overflow: hidden;">{{ articleTitle }}</a>
        </div>
    </div>
</template>

<style scoped>
.icon {
    width: 18px;
}
.cursor-pointer {
    cursor: pointer;
}
</style>

<script>
import { ContentTree } from '@/classes/tree';
import scrollToElement from '@/mixins/scrollToElement';
export default {
    name: 'TextSidebarTreeNode',
    props: {
        indent: {
            type: Number,
            default: 1
        },
        root: {
            type: Object,
            required: false 
        },
        node: {
            type: Object,
            required: true
        },
        contentTree: {
            type: ContentTree,
            required: false
        },
        version: {
            type: Object,
            required: false
        },
        isContainer: {
            type: Boolean,
            default: false
        },
        isArticle: {
            type: Boolean,
            default: false
        }
    },
	mixins:[scrollToElement],
    data() {
        return {
            expanded: true
        }
    },
    computed: {
        articleLink() {
            if (!this.isArticle || !this.version) return '#'
            return `/index.html?article=${this.node.id}&version=${this.version.id}`
        },
        articleTitle() {
            if (!this.isArticle || !this.version) return ''
            return !this.version.title ? this.node.title : this.version.title
        }
    },
    methods: {
        base64Content(version) {
            const binary = atob(version.html_content);
            const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
            return new TextDecoder("utf-8").decode(bytes);
        }
    }
}
</script>
